export interface SparklineProps {
  points: readonly number[];
  tone?: 'teal' | 'ok' | 'warn' | 'crit';
  label?: string;
}

/** The only chart allowed inside a table row. */
export function Sparkline({ points, tone = 'teal', label }: SparklineProps) {
  if (points.length < 2) {
    return <span className="o-muted">no series</span>;
  }
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;
  const width = 48;
  const height = 16;
  const step = width / (points.length - 1);
  const path = points
    .map((value, index) => {
      const x = (index * step).toFixed(2);
      const y = (height - ((value - min) / span) * height).toFixed(2);
      return `${index === 0 ? 'M' : 'L'}${x},${y}`;
    })
    .join(' ');

  return (
    <svg
      className="o-spark"
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={label ?? `Trend, ${points.length} points, latest ${points[points.length - 1]}`}
      preserveAspectRatio="none"
    >
      <path d={path} fill="none" stroke={`var(--${tone})`} strokeWidth="1.5" />
    </svg>
  );
}
